module.exports = __webpack_public_path__ + "static/media/flame.bf9ddaa6.svg";